import Cookies from 'js-cookie';
import { ILoginPrarm, ITempLoginPrarm, thirdTempLogin, thirdLogin } from '@src/apis/auth';
import { storage } from '@src/shared/storage';

// 处理 code 参数和获取 Token
export const handleCodeAndGetToken = async () => {
    const queryParams = new URLSearchParams(window.location.search);
    const code = queryParams.get('code') as string
    const params: ILoginPrarm = {
        org_key: __ORG_KEY__,
        third_auth_code: code,
        third_auth_type: 'fuTianAuth',
        redirect_url: window.location.origin + window.location.pathname
    }
    const tempParams: Pick<ITempLoginPrarm, 'org_key'> = {
        org_key: __ORG_KEY__,
    }
    try {
        const resp = code ? await thirdLogin(params) : await thirdTempLogin(tempParams)
        const token = resp.token;
        Cookies.set('token', token, { expires: 7, secure: true, sameSite: 'strict' });
        if (!code) {
            return
        }
        storage.set('user', resp)
        // 清除 URL 中的 code 参数
        const queryParams = new URLSearchParams(window.location.search);
        queryParams.delete('code');
        const newUrl = window.location.pathname + (queryParams.toString() ? `?${queryParams.toString()}` : '');
        window.history.replaceState({}, '', newUrl);
        window.location.href = window.location.origin + window.location.pathname
    } catch (error) {
        console.error('获取 Token 失败:', error);
    }
};
